<rask-page pageTitle="{{ getTitle() | translate }}">
  <ng-container header>
    @if (!isNew()) {
      <rask-action-button
        aid="buttonRadera"
        [disabled]="(!!form && form.disabled) || canSave()"
        (click)="deleteHandelssortiment()"
        icon="far fa-trash-alt">
        {{commonTexts.delete}}
      </rask-action-button>
    }
  </ng-container>
  @if (!!handelssortiment) {
    <rask-handelssortiment-header
      class="svea-transform"
      [validationContext]="validationContext"
      [relateradeHandelssortiment]="relateradeHandelssortiment"
      [form]="form"
      [(handelssortiment)]="handelssortiment"
      [foradlingsHandelssortiment]="foradlingsHandelssortiment"
      noBorder>
    </rask-handelssortiment-header>
  }
  @if (!!handelssortiment) {
    <rask-handelssortiment-sortiment
      class="svea-transform"
      [validationContext]="validationContext"
      [form]="form"
      [produkter]="produkter"
      [(handelssortimentSortiment)]="handelssortimentSortiment"
      [(handelssortiment)]="handelssortiment"
      [foradlingsHandelssortiment]="foradlingsHandelssortiment"
      noBorder>
    </rask-handelssortiment-sortiment>
  }
  @if (!!handelssortiment) {
    <rask-handelssortiment-matning
      class="svea-transform"
      [validationContext]="validationContext"
      [form]="form"
      [(handelssortiment)]="handelssortiment"
      noBorder>
    </rask-handelssortiment-matning>
  }
  @if (!!handelssortiment) {
    <rask-handelssortiment-produkt
      class="svea-transform"
      [validationContext]="validationContext"
      [produkter]="produkter"
      (changed)="productsChanged()"
      [disabled]="form.disabled"
      [handelssortiment]="handelssortiment"
      noBorder>
    </rask-handelssortiment-produkt>
  }
  <ng-container footerContent>
    <rask-save-button (click)="save()" [disabled]="!canSave()"></rask-save-button>
  </ng-container>
</rask-page>
